<template>
    <router-view></router-view>
</template>
<script>


	export default {
		data() {
			return {
				
			}
		},
		computed: {
			
		},
        created(){
            
        },
		mounted() {
		},
		methods: {}
	}
</script>
<style scoped lang="scss">
  
</style>
<style lang="scss">

</style>
